import AccordionHTML from "@components/accordions/accordionHTML";
import { ReactNode } from "react";
import { RaffleDefaultWordHowItWorksDrawLottery } from "./draw-lottery";
import { RaffleDefaultNumberHowItWorksDrawRandom } from "../../number/how-it-works/draw-random";

export function RaffleDefaultWordHowItWorksDraws() {
  const items: { title: string; html: ReactNode }[] = [
    {
      title: "Loteria Federal",
      html: RaffleDefaultWordHowItWorksDrawLottery(),
    },
    {
      title: "Sorteio Aleatório",
      html: RaffleDefaultNumberHowItWorksDrawRandom(),
    },
  ];

  return (
    <>
      <h5>Como é sorteado o ganhador da rifa?</h5>
      <p>
        Para este tipo de rifa, de palavras ou nomes, recomendamos duas modalidades, sendo
        elas como abaixo:
      </p>
      <div className="row">
        {/* Load the Explanations */}
        <AccordionHTML items={items} autoOpenKey={undefined} />
      </div>
    </>
  );
}
